module.exports = __webpack_public_path__ + "static/img/智慧气象展厅.90f6d2d0.png";